import React, { useState } from "react";
import {
  SectorData,
  SectorHeatmapWidget,
  SectorIndicesWidget,
  SectorPeerComparisonWidget,
  Region,
  TimePeriod,
  SectorIndicesWidgetProps,
  SectorHeatmapWidgetProps,
  SectorPeerComparisonWidgetProps,
  WidgetError,
  ThemeType,
  WidgetHeightMessage,
} from "@labci/bell-fg-widgets";

const SectorAnalysis: React.FC = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const [region, setRegion] = useState<Region>(
    (queryParams.get("region") as Region) || Region.AU,
  );
  const [period, setPeriod] = useState<TimePeriod>(
    (queryParams.get("period") as TimePeriod) || TimePeriod.ThreeMonths,
  ); //1D,1M, 3M, 6M, 1YR
  const [select, setSelect] = useState<string>(
    queryParams.get("select") || "50",
  );
  const [sector, setSector] = useState<string>(
    queryParams.get("select") || "50",
  ); //50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60 , 61, 62, 63
  const theme = queryParams.get("theme") || ThemeType.Direct;
  const token = queryParams.get("token") || "";
  //const tab = queryParams.get('tab') || ""; //summary, performance, technical, fundamentals, companyscore, ratings
  const [tab, setTab] = useState<string>("summary");
  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };
  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };
  const handleSectorCallback = (message: SectorData) => {
    //change to any type
    let msg = message as any;
    console.log("handleSectorIndicesCallback", msg);
    if (msg && msg.data && msg.data.sector) {
      setSector(msg.data.sector);
      setSelect(msg.data.sector + "");
    }
  };

  const SectorIndicesWidgetProps: SectorIndicesWidgetProps = {
    region: region,
    period: period,
    token: token,
    select: select,
    theme: theme as ThemeType,
    onCallback: handleSectorCallback,
    onError: handleError,
    onHeightChange: handleHeightChange,
  };

  const SectorHeatmapWidgetProps: SectorHeatmapWidgetProps = {
    region: region,
    period: period,
    token: token,
    theme: theme as ThemeType,
    onCallback: handleSectorCallback,
    onError: handleError,
    onHeightChange: handleHeightChange,
  };

  const SectorPeerComparisonWidgetProps: SectorPeerComparisonWidgetProps = {
    region: region,
    sector: sector,
    token: token,
    tab: tab,
    onError: handleError,
    theme: theme as ThemeType,
    onHeightChange: handleHeightChange,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "white",
        boxSizing: "border-box",
        overflow: "hidden",
        minWidth: "375px",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          flexShrink: 0,
        }}
      >
        <select
          value={region}
          onChange={(e) => setRegion(e.target.value as Region)}
        >
          <option value={Region.AU}>AU</option>
          <option value={Region.US}>US</option>
        </select>
        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value as TimePeriod)}
        >
          <option value={TimePeriod.Day}>1D</option>
          <option value={TimePeriod.Month}>1M</option>
          <option value={TimePeriod.ThreeMonths}>3M</option>
          <option value={TimePeriod.SixMonths}>6M</option>
          <option value={TimePeriod.Year}>1YR</option>
        </select>
      </div>
      {/* First row: SectorIndicesWidget and SectorHeatmapWidget */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          gap: "10px",
          marginBottom: "20px",
          flex: "0 1 auto",
          alignContent: "flex-start",
        }}
      >
        <div
          style={{
            flex: "1 1 calc(50% - 5px)",
            minWidth: "375px",
            height: "45vh",
            maxHeight: "45vh",
            overflow: "auto",
          }}
        >
          <SectorIndicesWidget {...SectorIndicesWidgetProps} />
        </div>
        <div
          style={{
            flex: "1 1 calc(50% - 5px)",
            minWidth: "375px",
            height: "45vh",
            maxHeight: "45vh",
            overflow: "auto",
          }}
        >
          <SectorHeatmapWidget {...SectorHeatmapWidgetProps} />
        </div>
      </div>
      {/* Second row: SectorPeerComparisonWidget */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          flex: "1 1 auto",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        {/* use a htmlto change tab: summary, performance, technical, fundamentals, companyscore, ratings */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            flexWrap: "wrap",
            flexShrink: 0,
          }}
        >
          <button onClick={() => setTab("summary")}>Summary</button>
          <button onClick={() => setTab("performance")}>Performance</button>
          <button onClick={() => setTab("technical")}>Technical</button>
          <button onClick={() => setTab("fundamentals")}>Fundamentals</button>
          <button onClick={() => setTab("companyscore")}>Company Score</button>
          <button onClick={() => setTab("ratings")}>Ratings</button>
        </div>
        <div
          style={{
            flex: "1 1 auto",
            overflow: "auto",
            minHeight: 0,
            width: "100%",
          }}
        >
          <SectorPeerComparisonWidget {...SectorPeerComparisonWidgetProps} />
        </div>
      </div>
    </div>
  );
};

export default SectorAnalysis;
